import React from 'react'
import { FormControl } from 'react-bootstrap'

export type TextInputProps = {
  type?: string
  submitting?: boolean
  name?: string
  value?: string
  placeholder?: string
  disabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  style?: React.CSSProperties
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  readOnly?: boolean
  autoFocus?: boolean
  inputRef?: React.RefObject<HTMLInputElement> | any
  maxLength?: number
}
/**
 * The primary text input
 */
export const TextInput = ({
  type = 'text',
  submitting,
  name,
  value,
  placeholder,
  disabled,
  onChange,
  onBlur,
  onFocus,
  style,
  onKeyDown,
  readOnly = false,
  autoFocus = true,
  inputRef,
  maxLength,
}: TextInputProps) => {
  const properValue = value ?? ''

  return (
    <FormControl
      onFocus={onFocus ?? ((e) => e.target.select())}
      ref={inputRef}
      type={type}
      disabled={disabled || submitting}
      {...{ onChange, value: properValue, onBlur, name, placeholder, style, onKeyDown, readOnly, autoFocus, maxLength }}
    />
  )
}
